/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import $ from 'jquery';
import FocusTrap from '../../../../../../javascript/utils/modal-focus-trap';

export class RegisterModal extends React.Component {
        static initClass() {
          this.propTypes = {
            eventName: PropTypes.string,
            eventLocation: PropTypes.string,
            eventPhotoUrl: PropTypes.string,
            // Callback to abort checkout
            onCancel: PropTypes.func,
            hideHeader: PropTypes.bool,
            // Modal container element
            modalContainerElement: PropTypes.element,
            isModalContainer: PropTypes.bool
          };
        }

        constructor(props) {
          super(props);
          this.componentDidMount = this.componentDidMount.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.setRef = this.setRef.bind(this);
this.closeModal = this.closeModal.bind(this);
          this._el = null;
          this._modalElementId = `register_modal_${Math.floor(Math.random() * 1000000000)}`;
        }

        componentDidMount() {
          $('html, body').addClass('em-scroll-body');
          setTimeout((() => $('.em-register_modal').addClass('em-open')), 0);
          if (this.props.isModalContainer) {
            return FocusTrap.trap(this._el, {priority: 1});
          }
        }

        componentWillUnmount() {
          $('html, body').removeClass('em-scroll-body');
          if (this.props.isModalContainer) {
            return FocusTrap.untrap();
          }
        }

        // Handle Escape key presses to close the modal
        onKeyDown(event) {
          if (event.defaultPrevented) { return; }

          switch (event.key) {
            case 'Escape':
              event.preventDefault();
              return this.closeModal(event);
          }
        }


        setRef(ref) { return this._el = ref; }

        closeModal(event) {
          return (typeof this.props.onHideModal === 'function' ? this.props.onHideModal(event) : undefined);
        }

        render() {
          return ReactDOM.createPortal(this.renderContent(), this.props.modalContainerElement);
        }

        renderContent() {
          return <div className="em-register_modal em-register-checkout"
                role="dialog"
                aria-modal="true"
                aria-labelledby={`${this._modalElementId  }_title`}
                onKeyDown={this.onKeyDown}
                ref={this.setRef}>
            <div className="em-modal_container">
              <div className="em-modal_header">
                <h2 id={`${this._modalElementId  }_title`}>{this.props.headerLabel}</h2>
                <a href="#" className="cancel_link em-link em-arrow-left" onClick={this.closeModal}>
                  <i className="fas fa-times"></i>
                  <span className="em-close_text">Close</span>
                </a>
              </div>
              <div className="em-modal_header-img">
                <img alt={this.props.eventPhotoCaption} className="img_big " height="150" src={this.props.eventPhotoUrl} width="200" />
              </div>
              {
                  !this.props.hideHeader && <h2>{this.props.eventName}</h2>
              }
              {
                  !this.props.hideHeader && <span className="em-register_event_address">{this.props.eventLocation}</span>
              }
              {this.props.children}
            </div>

            <div className="em-modal_overlay" onClick={this.props.closeModal}></div>
          </div>;
        }
      }
RegisterModal.initClass();
